export class BaseProvider {
    constructor(ProviderConstructor) {
        this.launchData = ProviderConstructor.launchData;
        this.user = ProviderConstructor.user;
        this.elementId = ProviderConstructor.elementId;
    }
}
